import React,{useState} from "react";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import { useDropzone } from 'react-dropzone';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';



const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      color: theme.palette.text.secondary,
    },
    formHeading:{
      fontSize:'20px !important',
      marginTop:0,
      marginBottom:10,
      textTransform:"uppercase",
      fontWeight:600,
      padding:'8px 24px'
    }
  }));
export default function UploadImageModal({onUpload}) {

    const classes = useStyles();
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    let files = acceptedFiles.map(file => (
        <li key={file.name}>
          {file.name} - {file.size} bytes
        </li>
      ));
      const handleUploadImage = async (e) => {
        e.preventDefault();
        onUpload(acceptedFiles);
      }
    return (
        <div>

            <Button type="button" variant="contained" color="primary" onClick={handleClickOpen}>Add New</Button>
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                 <h3 className={classes.formHeading}>Upload Images</h3>
                <DialogContent>
                    <div className={classes.root}>

                        <Grid container >

                            <Grid item xs={12}>
                             
                                
                                    <section className="container">
                                        <div {...getRootProps({ className: 'dropzone disabled' })}>
                                            <input {...getInputProps()} />
                                            <p>Drag 'n' drop some files here, or click to select files</p>
                                        </div>
                                        <aside>
                                            <h6 style={{ margin: 10 }}>Files</h6>
                                            <ul>{files}</ul>
                                        </aside>
                                    </section>
                                    
                                
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose} color="danger">
                        Close
                    </Button>
                    <Button type="button" onClick={handleUploadImage} variant="contained" color="primary">
                                         Upload Now
                                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}